import * as React from 'react';
import { FormSection } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';

import { Vehicle } from '@components/vehicle';

const View: React.SFC<any> = ({ form }) => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>

      <Row>
        <Col md={12}>
          <FormSection name="vehicle">
            <Vehicle form={form} formName="vehicle" />
          </FormSection>
        </Col>
      </Row>

      <Row>
        <Col className="grid-system-margin" />
      </Row>
    </Grid>
  </div>
);

export const WantedVehiclesFormVehicle = View;



// WEBPACK FOOTER //
// ./src/modules/wantedVehicles/WantedVehiclesFormVehicle.tsx